import React, { useContext } from 'react';
import { ColumnProps } from 'antd/lib/table';

import DeviceContext from '@totem/components/devices/deviceDetails/DeviceContext';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { DeviceSalesOrder } from '@totem/types/devices';

const SalesOrderLinesTable = () => {
  const { deviceData, loading } = useContext(DeviceContext);

  const columns: ColumnProps<DeviceSalesOrder>[] = [
    {
      title: 'Sales Order',
      dataIndex: 'salesOrderNumber',
      key: 'salesOrderNumber',
      sorter: (compA, compB) =>
        compA.salesOrderNumber.localeCompare(compB.salesOrderNumber),
    },
    {
      title: 'Line',
      dataIndex: 'lineNumber',
      key: 'lineNumber',
      width: 80,
      sorter: (compA, compB) => compA.lineNumber - compB.lineNumber,
    },
    {
      title: 'Service',
      dataIndex: 'service',
      key: 'service',
      sorter: (compA, compB) => compA.service.localeCompare(compB.service),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: (compA, compB) => compA.status.localeCompare(compB.status),
    },
  ];

  return (
    <IBTable
      showSorterTooltip
      columns={columns}
      dataSource={deviceData?.device?.salesOrders ?? []}
      loading={loading}
      rowKey={(record) =>
        record.salesOrderId + record.lineNumber + record.service
      }
      pagination={{ showSizeChanger: true }}
    />
  );
};

export default SalesOrderLinesTable;
